import { render, staticRenderFns } from "./CombinedFormReportChart.vue?vue&type=template&id=bd27530a"
import script from "./CombinedFormReportChart.vue?vue&type=script&lang=js"
export * from "./CombinedFormReportChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports